import { getDomainConfig } from '../config/config';
import { getLanguageCode } from './getURLParams';

export function formatCurrency(amount, region) {
  if (amount === undefined){
    return '0';
  }
  switch(region) {
    case 'de-de':
      return Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
      }).format(amount);
    case 'en-en':
      return Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP'
      }).format(amount);
    case 'en-au':
      return `A${Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD'
      }).format(amount)}`
    case 'en-ie':
      return Intl.NumberFormat('en-IE', {
        style: 'currency',
        currency: 'EUR'
      }).format(amount);
    case 'en-nl':
      return Intl.NumberFormat('en-NL', {
        style: 'currency',
        currency: 'EUR'
      }).format(amount);
    case 'en-us':
      return Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(amount);
  default:
    return amount;
  }
}

export function getGeo() {
  const config = getDomainConfig();
    if (config.brand === 'Atd') {

      const langPrefix = getLanguageCode('Atd');
      let langCode = '';

      switch(langPrefix) {
        case 'de':
          langCode = 'de-de';
          break;
          case 'en':
          langCode = 'en-en';
          break;
        case 'au':
          langCode = 'en-au';
        break;
          case 'ie':
          langCode = 'en-ie';
        break;
          case 'nl':
          langCode = 'en-nl';
        break;
          case 'us':
          langCode = 'en-us';
          break;
        default:
          langCode = langPrefix;
      }
      return langCode;
    }
    return 'en-en';
}